import { render, staticRenderFns } from "./HistoricalData-Stacked.vue?vue&type=template&id=6302d900&"
import script from "./HistoricalData-Stacked.vue?vue&type=script&lang=js&"
export * from "./HistoricalData-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalData-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports